const locale = {
  placeholder: "Selezionare l'orario",
};

export default locale;
